import { useCallback, useState } from "react";
import { useNavigate } from "react-router";

import { ConfirmModal, Modal } from "@prequel/shared-components";

import WebhookDetailsSection from "./WebhookDetailsSection";

import { useDeleteWebhook } from "@/api/queries/webhooks";
import DangerZone from "@/components/DangerZone";
import { ExistingWebhook } from "@/types";

interface WebhookDetailsProps {
  webhook: ExistingWebhook;
}

const WebhookDetails = ({ webhook }: WebhookDetailsProps) => {
  const navigate = useNavigate();
  const deleteWebhookMutation = useDeleteWebhook();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteConfirm = useCallback(() => {
    if (webhook) {
      deleteWebhookMutation.mutate({
        webhookId: webhook.id,
        redirectPath: "/webhooks",
      });
    }
    setIsDeleteModalOpen(false);
  }, [deleteWebhookMutation, webhook]);

  const onDelete = () => setIsDeleteModalOpen(true);

  const dangerZoneActions = [
    {
      label: "Edit webhook",
      description: "Edit webhook fields.",
      buttonText: "Edit webhook",
      onClick: () => navigate(`/webhooks/${webhook.id}/edit`),
    },
    {
      label: "Delete webhook",
      description: "Once you delete a webhook, the action cannot be undone.",
      buttonText: "Delete webhook",
      onClick: onDelete,
    },
  ];

  if (!webhook) {
    return null;
  }

  return (
    <>
      <Modal open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
        <ConfirmModal
          title="Delete webhook"
          message="Are you sure you want to delete this webhook? This action cannot be undone."
          onConfirm={handleDeleteConfirm}
          confirmButtonText="Delete"
          onCancel={() => setIsDeleteModalOpen(false)}
        />
      </Modal>
      <WebhookDetailsSection webhook={webhook} />
      <DangerZone actions={dangerZoneActions} />
    </>
  );
};

export default WebhookDetails;
